import { CirclePlus, Search } from 'lucide-react';
import { useState } from 'react';
import { AdminTab } from '.';
import { Button } from '../../components/Button';
import { DataTable } from '../../components/DataTable';
import { TextInput } from '../../components/Input/TextInput';
import { TabsList, TabsTrigger } from '../../components/Tabs';
import { useDebounce } from '../../hooks/useDebounce';
import { useSearchUsers } from '../hooks/useSearchUsers';
import { useUsersTableColumns } from '../hooks/useUsersTableColumns';
import { InviteUserModal } from './InviteUserModal';

export const UsersList = () => {
  const [showInviteUserModal, setShowInviteUserModal] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const searchTerm = useDebounce(searchInput, 200);
  const { users, isLoading } = useSearchUsers({ searchTerm });
  const columnDefinitions = useUsersTableColumns();

  return (
    <div className="flex flex-1 flex-col justify-between">
      <InviteUserModal open={showInviteUserModal} onOpenChange={setShowInviteUserModal} />

      <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
        <TabsList className="grid w-full grid-cols-3 md:w-[600px]">
          <TabsTrigger value={AdminTab.Users}>Users</TabsTrigger>
          <TabsTrigger value={AdminTab.Clinics}>Clinics</TabsTrigger>
          <TabsTrigger value={AdminTab.LifeglovLinerStock}>Liner Stock</TabsTrigger>
        </TabsList>

        <div className="flex items-center gap-5 md:pl-5">
          <TextInput
            icon={Search}
            initialValue={searchInput}
            placeholder="Search by name"
            onChange={setSearchInput}
            size="l"
            autoFocus
            testId="users-search-input"
          />
          <Button variant="primary" icon={CirclePlus} iconLayout="start" onClick={() => setShowInviteUserModal(true)}>
            <div className="hidden md:block">Invite User</div>
          </Button>
        </div>
      </div>
      <div className="overflow-auto">
        <DataTable
          rows={users}
          columns={columnDefinitions}
          pageSize={15}
          initialSorting={[{ id: 'lastName', desc: false }]}
          isLoading={!users.length && isLoading}
          stickyHeader
          className="mt-4 min-w-[1200px]"
          testId="users-list"
        />
      </div>
    </div>
  );
};
